import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { useAttorneyHubDispatch } from "_shared/_stores/redux-store";
import {
  getIndividualAvatar,
  getIndividualAvatarError,
  getIndividualAvatarIsLoading,
  populateIndividualAvatar,
} from "marketplace/individuals/_stores/individuals-redux-slice";
import Individual from "marketplace/individuals/individual";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const StyledAvatar = styled(Avatar)<{ disabled?: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}));
const LoadingProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  height: "75%",
  width: "75%",
}));

type IndividualAvatarProps = {
  className?: string;
  individual?: Individual;
  disabled?: boolean;
};

export default function IndividualAvatar(props: Readonly<IndividualAvatarProps>) {
  const { className, individual, disabled } = props;

  const dispatch = useAttorneyHubDispatch();

  const base64AvatarData = useSelector(getIndividualAvatar((individual?.profile.avatarId && individual.id ) ?? null));
  const isLoadingAvatar = useSelector(getIndividualAvatarIsLoading((individual?.profile.avatarId && individual.id ) ?? null));
  const errorLoadingAvatar = useSelector(getIndividualAvatarError((individual?.profile.avatarId && individual.id) ?? null));
  
  useEffect(() => {
    if (base64AvatarData || !individual?.profile.avatarId || isLoadingAvatar || errorLoadingAvatar) return;
    dispatch(populateIndividualAvatar({ individualId: individual.id }));
  }, [dispatch, individual?.profile.avatarId?.value, isLoadingAvatar, errorLoadingAvatar, base64AvatarData, individual?.profile.avatarId, individual?.id]);

  return (
    <>
      {(base64AvatarData) ? (
        <StyledAvatar 
          className={className}
          disabled={disabled}
          src={base64AvatarData}
        >
          {
            !base64AvatarData 
            && isLoadingAvatar 
            && !errorLoadingAvatar 
            && <LoadingProgress disableShrink />
          }
        </StyledAvatar>
      ) : (
        <Avatar className={className} />
      )}
    </>
  );
}
